
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8aaR3", function(module, exports) {

$parcel$export(module.exports, "LazyRepliesListAsync", () => $8dd81752a3ba7899$export$eaf190c694dea378);
$parcel$export(module.exports, "default", () => $8dd81752a3ba7899$export$2e2bcd8739ae039);

var $bQWwW = parcelRequire("bQWwW");

const $8dd81752a3ba7899$export$eaf190c694dea378 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("jl1cm")), {
    moduleId: "./src/packages/issue/issue-view-activity-comment/src/comment-replies/replies-list/index.tsx"
});
var $8dd81752a3ba7899$export$2e2bcd8739ae039 = $8dd81752a3ba7899$export$eaf190c694dea378;

});
parcelRegister("jl1cm", function(module, exports) {

let $e140e874cdefd30f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e140e874cdefd30f$var$load("ej9s8").then(()=>parcelRequire('1obZq'));

});



$parcel$global.rlb("a3q1T")
//# sourceMappingURL=async.2e9fadbc.js.map
